export const name = 'TemplateListController';
export default function TemplateListController($q, templatesService, $log, $mdDialog, $state, $scope, $timeout, $document,
                                               errorDialogOpen, stateKeeperService, chipsService, impositionTemplatesService, $rootScope, analyticsFactory,
                                               $filter,$translate, listManagementFactory, pusherChannel, $window,
                                               $interval, closeDialogFromOutsideHelperFactory) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

  vm.typingTimer = null;
  vm.allTag = "All";
  vm.detailedViewAllowed = false;
  vm.listUtility = null;
  vm.searchText = null;
  vm.closeUploadDialog = closeDialogFromOutsideHelperFactory.createCloseDialogFromOutsideHelperObject();
  vm.initializing = true;
  vm.templatesService = templatesService;
  vm.openUploadDialog = openUploadDialog;
  vm.deleteTemplates = deleteTemplates;
  vm.listFilterPredicate = listFilterPredicate;
  vm.editTags = editTags;
  vm.getErrorIcon = getErrorIcon;
  vm.getWarningIcon = getWarningIcon;
  vm.getDiverImage = getDiverImage;
  vm.onViewErrorDetails = onViewErrorDetails;


  vm.pagination = {
    limit: 15,
    page: 1,
    elementsPerPageOptions: [15, 20, 30]
  };

  vm.fileUploadProps = {
    knownProgress: false,
    accept: '.hpd',
    fileTypeToDisplay: 'HPD',
    uploadProgress: 0,
    showProgressBar: false,
    reset: false,
    onFileSelect: onFileSelect
  };

  vm.thumbnailWidth = 210;
  vm.thumbnailHeight = 210;
  vm.activateHttpPageReset = false;

  let iconsRequire = require.context('@printos/imposer-ui/src/components/templates/images/icons', false, /\.svg/);
  let errorIcon = iconsRequire("./error.svg");
  let warningIcon = iconsRequire("./warning.svg");
  let diverImage = iconsRequire("./diver.svg");

  vm.isDetailedButtonAllowed = function () {
    return vm.listUtility.selected.length === 1 && vm.initializing === false && (vm.listUtility.selected[0].templateCreationStatus === 'Ready' || vm.listUtility.selected[0].templateCreationStatus === 'Warning');
  };

  vm.showDetails = function (event, template) {
    let functionName = 'TemplateListController.showDetails';
    $log.info(angular.toJson({action: 'function called', functionName: functionName}));

    event.preventDefault();
    event.stopPropagation();

    $log.info(angular.toJson({
      action: 'new selected',
      functionName: functionName,
      selectedId: vm.listUtility.selected[0],
      prevSelectedId: vm.prevSelectedId
    }));

    if (!template) {
      template = vm.listUtility.selected[0];
    } else {
      vm.listUtility.theList.map(curr => {
        if(curr.templateId !== template.templateId){
          curr.isSelected = false;
        }
      });
      template.isSelected = true;
      vm.listUtility.selected = [template];
    }

    if (template.templateCreationStatus !== 'Ready' && template.templateCreationStatus !== 'Warning') {
      return;
    }

    stateKeeperService.keepState('listView', vm.viewTypeSelection);
    analyticsFactory.eventTrack(analyticsFactory.actions.enterDetailedTemplatePage, analyticsFactory.categories.composer, analyticsFactory.labels.general, null);
    $state.transitionTo('templates.templatedetails', {
      composerTemplateId: template.templateId,
      compositionTemplate: template
    });

    $log.info(angular.toJson({action: 'function return', functionName: functionName}));
  };

  angular.element(document).ready(function () {
    $interval(function () {
      vm.activateHttpPageReset = true;
    }, 5000, 1);
  });

  (function activate() {
    vm.viewTypeSelection = stateKeeperService.getState('listView');
    if ((vm.viewTypeSelection === undefined) || (vm.viewTypeSelection === null)) {
      vm.viewTypeSelection = new ViewTypeSelection();
      vm.viewTypeSelection.setThumbnailView();
    }

    initializeImpositionTemplates();

    vm.listUtility = listManagementFactory.getMonitoringListService();

    let docWidth = $(document).width() - 143;

    if(docWidth < 1281){
      docWidth = docWidth + ((docWidth - 60) * 0.02);
    }
    let numberOfThumbsPerRow = Math.round(docWidth / 235) - 1;
    let minimumThumbsPageLimit = Math.ceil(Math.ceil((($(document).height() - 250) / 240)) * numberOfThumbsPerRow) - 1;
    while(minimumThumbsPageLimit < 15){
      minimumThumbsPageLimit += numberOfThumbsPerRow;
    }
    let listInitParams = {
      listName: 'CompositionList',
      fetchListByPageFunc: getTemplatesByPage,
      getChannelNameFunc: pusherChannel.getChannelName,
      entryUUIDFieldName: "templateId",
      entryIdentificationFieldName: "templateId",
      entryNameFieldName: "templateName",
      listOfDateAttributesToFormat: ['uploadTime'],
      placeToAddNewElementToList: listManagementFactory.addNewToBeginningOfList,
      isMultiSelect: true,
      pagination: {
        limit: minimumThumbsPageLimit,
        page: 1,
        elementsPerPageOptions: [minimumThumbsPageLimit, Math.floor(minimumThumbsPageLimit * 2 + 1), Math.floor(minimumThumbsPageLimit * 3 + minimumThumbsPageLimit + 3)]
      },
      events: {
        addedEntry: "HPD_LIST_ENTRY_ADDED",
        deletedEntry: "HPD_LIST_ENTRY_DELETED",
        changedEntry: "HPD_LIST_ENTRY_CHANGED"
      },
      callbacks: {
        onAddedEntry: onAddedEntryCallback,
        onDeletedEntry: null,
        onChangedEntry: onChangedEntryCallback,
        onFileSelect: null,
        actionBeforeDeletion: actionBeforeDeletion,
        actionBeforeAddedChanged: actionBeforeAddedChanged,
        actionBeforeChangedOnOldData: actionBeforeChangedOnOldData
      }
    };

    vm.listUtility.initialize(listInitParams).then(
      function (theList) {
        //Update predefined templates
        templatesService.updatePredefinedTemplates();
      }, function (status) {
        errorDialogOpen.openErrorDialog(status);
      }
    );
  }());

  function getTemplatesByPage(page, pageSize, filter, tag, isInitializing) {
    let functionName = 'TemplateListController.getTemplatesByPage';
    $log.info(angular.toJson({action: 'function called', functionName: functionName}));

    let defer = $q.defer();
    vm.initializing = isInitializing;
    templatesService.getTemplatesByPage(page, pageSize, filter, tag, isInitializing).then(response => {

      response.compositionTemplates.forEach(template => updateTagsForTemplate(template));

      let listCollection = {
        listOfElements: response.compositionTemplates,
        totalNumberOfElements: response.totalNumberOfTemplates,
        numberOfFilteredElements: response.numberOfFilteredTemplates
      };

      if (isInitializing) {
        chipsService.clearChips();
        chipsService.addChips(response.tags);
        vm.listUtility.tags = chipsService.getChips();
      }

      vm.initializing = false;
      defer.resolve(listCollection);
    }, error => {
      vm.initializing = false;
      defer.reject(error.status);
    });

    return defer.promise;
  }

  function updateTagsForTemplate(template) {
    if ((template.tags === undefined) || (template.tags === null)) {
      template.tags = "";
      template.tagObjects = [];
    } else {
      template.tagObjects = chipsService.parseChipsListString(template.tags);
      if ((template.tagObjects === undefined) || (template.tagObjects === null)) {
        template.tagObjects = [];
      }
    }

    template.updateTagsCallback = updateTagsCallback;
  }

  function initializeImpositionTemplates() {
    impositionTemplatesService.checkDefaultTemplatesLoading();
  }

  function updateTagsCallback(selectedChips) {
    let chipsString = chipsService.convertToChipsString(selectedChips);
    let _this = this;
    let templateId = _this.templateId;
    templatesService.updateTags(templateId, chipsString).then(
      function (tags) {
        _this.tags = chipsString;
        _this.tagObjects = selectedChips;
        vm.listUtility.tags = angular.copy(chipsService.getChips());

        if (vm.listUtility.selectedTag !== vm.allTag && selectedChips.length === 0) {
          vm.listUtility.theList = vm.listUtility.theList.filter(curr => curr.templateId !== templateId);
          vm.listUtility.selected = vm.listUtility.selected.filter(curr => curr.templateId !== templateId);

          if (vm.listUtility.tags.indexOf(vm.listUtility.selectedTag) === -1) {
            vm.listUtility.selectedTag = vm.allTag;
            vm.listUtility.refreshList();
          }
        }
      },
      function (error) {
        switch (error) {
          case 406:
            let errorInfo = {
              smsError: {
                httpStatusCode: 406, subCode: -1, message: "Tag length is restricted to 50 letters"
              }
            };
            errorDialogOpen.openErrorDialog(errorInfo);
            break;
          default:
            errorDialogOpen.openErrorDialog();
            break;
        }
      }
    );
  }

  function deleteTemplates($event) {
    var functionName = 'TemplateListController.deleteTemplate';
    $log.info(angular.toJson({action: 'function called', functionName: functionName}));
    let templateName = '';
    if (vm.listUtility.selected.length === 0) {
      return;
    } else if (vm.listUtility.selected.length === 1) {
      templateName = vm.listUtility.selected[0].templateName;
    }

    let templatesIds = vm.listUtility.selected.map(curr => curr.templateId);
    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('./delete-template/templatedelete.html'),
      controller: 'TemplateDeleteController',
      bindToController: true,
      controllerAs: 'templateDeleteController',
      locals: {templatesIds: templatesIds, templateName: templateName}
    }).then(function (data) {
      $log.info(angular.toJson({action: 'dialog closed successfully', functionName: functionName}));
    });

    $log.info(angular.toJson({action: 'function return', functionName: functionName}));
  }

  function openUploadDialog($event) {
    var functionName = 'TemplateListController.openUploadDialog';
    $log.info(angular.toJson({action: 'function called', functionName: functionName}));

    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('./templateUpload.html'),
      controller: 'TemplateUploadController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {templateList: vm.listUtility.theList, closeDialogFromOutsideHelperObject: vm.closeUploadDialog}
    }).then(function (template) {
      $log.info(angular.toJson({
        action: 'dialog closed successfully',
        functionName: functionName,
        template: template
      }));
    });

    $log.info(angular.toJson({action: 'function return', functionName: functionName}));
  }

  function processingComplete(template) {
    template.updateTagsCallback = updateTagsCallback;
    template.tagObjects = [];
    template.tags = "";

    if (template.engineErrorForErrorPopup) {
      errorDialogOpen.openErrorDialog(template.engineErrorForErrorPopup);
    }
  }

  function ViewTypeSelection() {

    this.ListViewConst = "ListView";
    this.ThumbnailViewConst = "ThumbnailView";
    this.selectedViewType = "ListViewConst";

    this.setListView = function () {
      this.selectedViewType = this.ListViewConst;
      analyticsFactory.eventTrack(analyticsFactory.actions.enterThumbnailsView, analyticsFactory.categories.composer, analyticsFactory.labels.general, null);
    };

    this.setThumbnailView = function () {
      this.selectedViewType = this.ThumbnailViewConst;
      analyticsFactory.eventTrack(analyticsFactory.actions.enterThumbnailsView, analyticsFactory.categories.composer, analyticsFactory.labels.general, null);
    };
  }

  $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
    /* if((to.name === 'templates')){ // && (from.name === 'templates.templatedetails')
		 vm.searchText = "";
		 if(vm.selectedId && vm.templateList && vm.templateList.length > 0){
			 reloadEditedTemplate(vm.selectedId);
			 let templateIndex = templateIdToTemplateListIndex(vm.selectedId);
			 calculateIdDeleteButtonDisabled(vm.templateList[templateIndex]);

		 }else{
			 activate();
		 }
	 }*/

    if (from.name === 'templates') {
      vm.closeUploadDialog.close();
    }
  });

  function templateIdToTemplateListIndex(templateId) {
    for (let iTemplate = 0; iTemplate < vm.listUtility.theList.length; iTemplate++) {
      if (vm.listUtility.theList[iTemplate].templateId === templateId) {
        return iTemplate;
      }
    }
    return null;
  }

  function listFilterPredicate(template) {
    let isMatch = false;
    let templateName = template.templateName.toLowerCase();
    let tags = template.tags ? template.tags.toLowerCase() : null;
    let status = template.statusDisplayText ? $translate.instant(template.statusDisplayText).toLowerCase() : null;
    let description = template.templateDescription ? template.templateDescription.toLowerCase() : null;

    if ((vm.searchText !== undefined) && (vm.searchText !== null) && (vm.searchText.length > 0)) {
      let searchText = vm.searchText.toLowerCase();
      if ((templateName.indexOf(searchText) !== -1) ||
        (tags !== null && tags.indexOf(searchText) !== -1) ||
        (status !== null && status.indexOf(searchText) !== -1) ||
        description !== null && description.indexOf(searchText) !== -1) {
        isMatch = true;
      }
    } else {
      isMatch = true;
    }

    return isMatch;
  }

  function editTags($event) {
    if (vm.listUtility.selected.length !== 1) {
      return;
    }
    // in case the template is not in ready state - return
    let templateIndex = templateIdToTemplateListIndex(vm.listUtility.selected[0].templateId);
    if (vm.listUtility.theList[templateIndex].templateCreationStatus !== 'Ready' && vm.listUtility.theList[templateIndex].templateCreationStatus !== 'Warning') {
      return;
    }
    chipsService.invokeChipsEditor($event, vm.listUtility.theList[templateIndex].tagObjects, vm.listUtility.theList[templateIndex].updateTagsCallback, vm.listUtility.theList[templateIndex]);
  }

  function getErrorIcon() {
    return errorIcon;
  }

  function getWarningIcon() {
    return warningIcon;
  }

  function getDiverImage() {
    return diverImage;
  }

  function onViewErrorDetails(template, $event) {
    $event.preventDefault();
    $event.stopPropagation();

    let errorContent = [];
    errorContent.push({
      title: $translate.instant('imposer.composer-main.Composer_Error_Details') + ':',
      body: template.engineError,
      rowType: 'message',
      additionalBody: template.warnings,
      shouldTranslate: false
    });

    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('@printos/imposer-ui/src/components/templates/error-dialog-more-info/errorDialogMoreInfo.html'),
      controller: 'ErrorDialogMoreInfoController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {dialogTitle: template.templateName + ".HPD", errorContent: errorContent}
    }).then(function () {

    }, function () {

    });
  }

  function onFileSelect(files, $event) {
    let fileSelected = files[0];
    let functionName = 'TemplateListController.onFileSelect';
    $log.info(angular.toJson({action: 'function called', functionName: functionName, fileName: fileSelected.name}));

    vm.fileUploadProps.fileSelected = fileSelected;
    vm.fileUploadProps.reset = false;
    vm.fileUploadProps.reset = true;
    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('./templateUpload.html'),
      controller: 'TemplateUploadController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {
        templateList: vm.listUtility.theList,
        closeDialogFromOutsideHelperObject: vm.closeUploadDialog,
        fileUploadProps: vm.fileUploadProps
      }
    }).then(function (template) {
      $log.info(angular.toJson({
        action: 'dialog closed successfully',
        functionName: functionName,
        template: template
      }));
    });

    /*      let templateEntryCreationRequest = {
			templateName:fileSelected.name.substr(0, fileSelected.name.lastIndexOf('.'))
		  };

		  templatesService.uploadTemplate(fileSelected, templateEntryCreationRequest,vm.templateList,this.uploadProgressCallback, null, vm.uploadContoller).then(
			function () {
			  $log.info(angular.toJson({action:'file uploaded successfully', functionName:functionName}));
			  vm.fileUploadProps.showDropArea = true;
			  vm.fileUploadProps.showProgressBar = false;
			  vm.fileUploadProps.uploadProgress = false;
			  vm.fileUploadProps.knownProgress = false;
			  vm.fileUploadProps.reset = true;
			}, function(status) {
			  $log.info(angular.toJson({action:'error uploading file', functionName:functionName}));
			  $mdDialog.cancel();

			  errorDialogOpen.openErrorDialog(status);

			});*/

    $log.info(angular.toJson({action: 'function return', functionName: functionName}));
  }


  /*********************************Callbacks************************************/

  function actionBeforeDeletion(templatesToDelete) {

    templatesToDelete.forEach(template =>{
      if (template.tagObjects && template.tagObjects.length > 0) {
        chipsService.removeChips(template.tagObjects);
        let tags = chipsService.getChips();
        vm.listUtility.tags = angular.copy(tags);
      }
    });
  }

  function actionBeforeAddedChanged(addedTemplate) {
    templatesService.addDisplayStatusToTemplate(addedTemplate);
    addedTemplate.updateTagsCallback = updateTagsCallback;
  }

  function onAddedEntryCallback(addedTemplate) {
    if (addedTemplate.templateCreationStatus === 'Ready') {
      processingComplete(addedTemplate);
    }
  }

  function actionBeforeChangedOnOldData(TemplateBeforeChange) {
    if (TemplateBeforeChange.tagObjects && TemplateBeforeChange.tagObjects.length > 0) {
      chipsService.removeChips(TemplateBeforeChange.tagObjects);
    }
  }

  function onChangedEntryCallback(changedEntryData) {
    changedEntryData.tagObjects = chipsService.parseChipsListString(changedEntryData.tags);
    if ((changedEntryData.tagObjects === undefined) || (changedEntryData.tagObjects === null)) {
      changedEntryData.tagObjects = [];
    } else {
      chipsService.addChips(changedEntryData.tagObjects);
    }
    if(changedEntryData.tagObjects.includes(vm.listUtility.selectedTag) === false && vm.listUtility.selectedTag !== vm.listUtility.all){
      vm.listUtility.removeFromList(changedEntryData);
    }
    vm.listUtility.tags = angular.copy(chipsService.getChips());
  }

  /*********************************Keys handling************************************/

  $document.bind('keyup', function (e) {
    if (e.keyCode === 46 && $state.current.name === "templates") {
      vm.deleteTemplates(e);
    }
  });

  $scope.$on('$destroy', function () {
    vm.listUtility.close();
  });
}
